import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import classdata from './modules/class'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    classdata
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js